/**
 * Observations Service
 * Observations management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ObservationGroupResponseDto { 
    /**
     * Observation group identifier
     */
    id: string;
    /**
     * Group name
     */
    name: string;
    /**
     * URL-friendly slug
     */
    slug: string;
    /**
     * Group description
     */
    description?: string;
    /**
     * Group status
     */
    status: ObservationGroupResponseDto.StatusEnum;
    /**
     * Metadata
     */
    metadata?: any;
    /**
     * Number of observation types in group
     */
    elementCount?: number;
    /**
     * Created on
     */
    createdOn?: string;
    /**
     * Updated on
     */
    updatedOn?: string;
}
export namespace ObservationGroupResponseDto {
    export type StatusEnum = 'draft' | 'active' | 'inactive';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


